module.exports = __webpack_public_path__ + "static/media/Calentadorenlinea.3834dd7c.pdf";